import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { CardMenuType } from '@/types';

export interface IAdjustCollapseModel {
    destroy: () => void;
    /** 当前面板类型 */
    currentType: CardMenuType | '';
    /** 设置当前面板类型 */
    setCurrentType: (payload: CardMenuType | '') => void;
}

const useAdjustCollapseModel = create<IAdjustCollapseModel>()(
    immer((set) => ({
        destroy: () =>
            set((state) => {
                state.currentType = '';
            }),
        currentType: '',
        setCurrentType: (payload) =>
            set((state) => {
                state.currentType = payload;
            }),
    })),
);

export { useAdjustCollapseModel };
export const getAdjustCollapseModel = () => useAdjustCollapseModel.getState();
